"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/VAFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_243)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_243`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V23.9995H-6V0Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12 0H30V24.0003H12V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M16.5951 10.4419L18.8503 13.4252C18.495 13.9632 18.4969 14.6881 18.9077 15.2317C19.429 15.9213 20.4106 16.0577 21.1002 15.5365C21.7897 15.0152 21.9262 14.0337 21.4049 13.344C20.9941 12.8004 20.2971 12.601 19.6826 12.7959L16.1678 8.14624L15.3355 8.77547L14.0868 9.71934L15.3453 11.3841L16.5951 10.4419ZM19.8418 13.8717C19.8965 13.8304 19.9587 13.8003 20.025 13.783C20.0914 13.7657 20.1604 13.7617 20.2283 13.7711C20.2962 13.7806 20.3615 13.8033 20.4206 13.838C20.4797 13.8727 20.5314 13.9187 20.5727 13.9733C20.614 14.028 20.6442 14.0903 20.6614 14.1566C20.6787 14.2229 20.6827 14.2919 20.6733 14.3598C20.6638 14.4277 20.6411 14.493 20.6064 14.5521C20.5718 14.6112 20.5258 14.6629 20.4711 14.7042C20.3607 14.7877 20.2217 14.8238 20.0846 14.8048C19.9475 14.7857 19.8237 14.713 19.7402 14.6026C19.6568 14.4922 19.6206 14.3532 19.6396 14.2161C19.6587 14.0791 19.7314 13.9552 19.8418 13.8717Z",
					fill: "#ACABB1"
				}),
				/* @__PURE__ */ n("path", {
					d: "M20.4633 11.3841L21.7219 9.71934L20.4732 8.77547L19.6408 8.14624L16.126 12.7959C15.5115 12.6008 14.8146 12.8004 14.4037 13.344C13.8824 14.0337 14.0189 15.0152 14.7085 15.5365C15.3981 16.0578 16.3797 15.9213 16.901 15.2317C17.3119 14.6881 17.3138 13.9632 16.9584 13.4252L19.2135 10.4419L20.4633 11.3841ZM16.0685 14.6024C15.9851 14.7128 15.8612 14.7855 15.7241 14.8046C15.587 14.8236 15.448 14.7875 15.3376 14.704C15.2272 14.6206 15.1545 14.4967 15.1354 14.3596C15.1164 14.2225 15.1526 14.0835 15.236 13.9731C15.2773 13.9185 15.329 13.8725 15.3881 13.8378C15.4472 13.8031 15.5126 13.7804 15.5804 13.7709C15.6483 13.7615 15.7174 13.7655 15.7837 13.7828C15.85 13.8 15.9123 13.8302 15.9669 13.8715C16.0216 13.9128 16.0676 13.9645 16.1023 14.0236C16.137 14.0827 16.1597 14.148 16.1691 14.2159C16.1785 14.2838 16.1745 14.3529 16.1572 14.4192C16.14 14.4855 16.1098 14.5477 16.0685 14.6024Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_243`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as VAFlag };
